import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, DateField } from './util';

@ModelInstance({
  mappingFields: {
    id: 'id',
    tournament_team_user_id: 'tournamentTeamUserId',
    date_from: 'dateFrom',
    date_to: 'dateTo',
    matches_count: 'matchesCount',
    reason: 'reason',
    is_conditional: 'isConditional',
  },
  relation: {
    dateFrom: DateField,
    dateTo: DateField,
  }
})
export class TournamentDisqualification extends BaseModel {
  id: number;
  tournamentTeamUserId: number;
  dateFrom: Date;
  dateTo: Date;
  matchesCount: number;
  reason: string;
  isConditional: boolean;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
